import { useContext } from 'react';
import { PermissionEn } from '@martech-solution/utils/constants';
import { AppContext } from 'src/contexts/app.context';
import type { IResourceFullAccessDetail } from 'src/types/master_data/userResource.type';
import { useBasePath } from '@martech-solution/utils/hooks';

function usePermission({ path }: { path?: string }) {
  const { resources } = useContext(AppContext);
  const basePath = useBasePath();

  const getListPermission = () => {
    let _path = path ?? basePath;
    const permissions = resources?.find((x) => x?.path === _path)?.permissions;
    return permissions;
  };

  const listPermission = getListPermission();

  const isRead = !!listPermission?.includes(PermissionEn.read);
  const isViewDetail = !!listPermission?.includes(PermissionEn.viewDetail);
  const isCreate = !!listPermission?.includes(PermissionEn.create);
  const isUpdate = !!listPermission?.includes(PermissionEn.update);
  const isDelete = !!listPermission?.includes(PermissionEn.delete);
  const isApprove = !!listPermission?.includes(PermissionEn.approve);
  const isReject = !!listPermission?.includes(PermissionEn.reject);
  const isApprove_solution = !!listPermission?.includes(PermissionEn.approve_solution);
  const isAssign = !!listPermission?.includes(PermissionEn.assign);
  const isCreate_leave_ticket = !!listPermission?.includes(PermissionEn.create_leave_ticket);
  const isAdmin = !!listPermission?.includes(PermissionEn.admin);
  const isGetQr = !!listPermission?.includes(PermissionEn.get_qr);
  const isConfigField = !!listPermission?.includes(PermissionEn.config_field);
  const isConfirmTransportation = !!listPermission?.includes(PermissionEn.confirm_transportation);

  return {
    isRead,
    isViewDetail,
    isCreate,
    isUpdate,
    isDelete,
    isApprove,
    isReject,
    isApprove_solution,
    isAssign,
    isCreate_leave_ticket,
    isAdmin,
    isGetQr,
    isConfigField,
    isConfirmTransportation
  };
}
export function usePermissionNew(
  paths?: string[],
  resourcesParam?: IResourceFullAccessDetail[],
  ticketCategoryCode?: string
) {
  const { resources } = useContext(AppContext);
  const basePath = useBasePath();
  const resourceList = resourcesParam ?? resources;

  const getPermissions = () => {
    if (ticketCategoryCode) {
      const permission = resourceList?.find((x) => x?.hrTicketCategoryCode === ticketCategoryCode);
      return permission ? [permission] : [];
    }

    if (!paths) {
      const permission = resourceList?.find((x) => x?.path === basePath);
      return permission ? [permission] : [];
    }

    return paths.map((path) => resourceList?.find((x) => x?.path === (path ?? basePath))).filter(Boolean);
  };

  return getPermissions();
}

export default usePermission;
